"use client";

import { useState, useEffect } from "react";
import "./NavBar.css";
import logo from "../../assets/DHMS_logo.webp";

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        !event.target.closest(".mobile-nav") &&
        !event.target.closest(".mobile-menu-btn")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);
    window.addEventListener("scroll", handleScroll);

    // Prevent body scroll when mobile menu is open
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
      window.removeEventListener("scroll", handleScroll);
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { path: "#features", label: "Features" },
    { path: "#pricing", label: "Pricing" },
    { path: "#contact", label: "Contact us" },
  ];

  const handleNavClick = (e, path) => {
    e.preventDefault();
    if (path.startsWith("#")) {
      // Check if we're on the landing page
      const currentPath = window.location.pathname;
      const isOnLandingPage = currentPath === "/" || currentPath === "/landing";

      if (isOnLandingPage) {
        // Already on landing page, just scroll
        const element = document.querySelector(path);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
          closeMobileMenu();
        }
      } else {
        // Navigate to landing page first, then scroll
        window.location.href = `/landing${path}`;
      }
    } else {
      window.location.href = path;
    }
  };

  return (
    <header className={`Nav-header ${isScrolled ? "scrolled" : ""}`}>
      <div className="Nav-container">
        <div className="logo-section">
          <a href="/" aria-label="Home">
            <img
              src={logo || "/placeholder.svg"}
              alt="DHMS Logo"
              className="logo-image"
            />
          </a>
        </div>

        <nav className="desktop-nav" aria-label="Main navigation">
          <ul className="n-nav-links">
            {navLinks.map((link) => (
              <li key={link.path}>
                <a
                  href={link.path}
                  className="n-nav-link"
                  onClick={(e) => handleNavClick(e, link.path)}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="desktop-actions">
          <a href="/login">
            <button className="btn1 btn-outline1" aria-label="Log in">
              Log in
            </button>
          </a>
          <a href="/signup">
            <button className="btn1 btn-primary1" aria-label="Get started">
              Get started
            </button>
          </a>
        </div>

        <button
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className={`hamburger ${isMobileMenuOpen ? "active" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      <div
        className={`mobile-nav ${isMobileMenuOpen ? "open" : ""}`}
        aria-hidden={!isMobileMenuOpen}
      >
        <ul className="mobile-nav-links">
          {navLinks.map((link) => (
            <li key={`mobile-${link.path}`}>
              <a
                href={link.path}
                className="mobile-nav-link"
                onClick={(e) => handleNavClick(e, link.path)}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="mobile-actions">
          <a href="/login">
            <button className="mobile-btn btn-outline" onClick={closeMobileMenu}>
              Log in
            </button>
          </a>
          <a href="/signup">
            <button className="mobile-btn btn-primary" onClick={closeMobileMenu}>
              Get started
            </button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
